import LandingPackages from "@/modules/oss_configs/components/landing_package/LandingPackage";
import LandingPackageClassesList from "@/modules/oss_configs/components/landing_package/ListClasses";
import LandingPackageForm from "@/modules/oss_configs/components/landing_package/Form";
import LandingPackagePackagesList from "@/modules/oss_configs/components/landing_package/ListPackages";

import WebappBanners from "@/modules/oss_configs/components/webapp_banners/ListBanner";
import WebappBannersForm from "@/modules/oss_configs/components/webapp_banners/Form";

import AndroidBanners from "@/modules/oss_configs/components/android_banners/ListBanner";
import AndroidBannersForm from "@/modules/oss_configs/components/android_banners/Form";

import iosBanners from "@/modules/oss_configs/components/ios_banners/ListBanner";
import iosBannersForm from "@/modules/oss_configs/components/ios_banners/Form";

import LandingBanners from "@/modules/oss_configs/components/landing_banners/ListBanner";
import LandingBannersForm from "@/modules/oss_configs/components/landing_banners/Form";

export default [
    {
        path: "/landing-packages",
        name: "LandingPackages",
        component: LandingPackages,
    },
    {
        path: "/landing-packages/form",
        name: "LandingPackageForm",
        component: LandingPackageForm,
    },
    {
        path: "/landing-packages/:id",
        name: "LandingPackageClassesList",
        component: LandingPackageClassesList,
    },
    {
        path: "/landing-packages/:id/:kelas",
        name: "LandingPackagePackagesList",
        component: LandingPackagePackagesList,
    },
    {
        path: "/webapp-banners",
        name: "WebappBanners",
        component: WebappBanners,
    },
    {
        path: "/webapp-banners/form",
        name: "WebappBannersForm",
        component: WebappBannersForm,
    },
    {
        path: "/android-banners",
        name: "AndroidBanners",
        component: AndroidBanners,
    },
    {
        path: "/android-banners/form",
        name: "AndroidBannersForm",
        component: AndroidBannersForm,
    },
    {
        path: "/ios-banners",
        name: "IosBanners",
        component: iosBanners,
    },
    {
        path: "/ios-banners/form",
        name: "IosBannersForm",
        component: iosBannersForm,
    },
    {
        path: "/landing-banners",
        name: "LandingBanners",
        component: LandingBanners,
    },
    {
        path: "/landing-banners/form",
        name: "LandingBannersForm",
        component: LandingBannersForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/oss_configs/router/oss_config.js